module.exports = __webpack_public_path__ + "img/aside-right-hand.f56a4367.png";